import { Component, Inject, OnDestroy } from '@angular/core';
import { Observable, firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionList } from '@vendasta/rx-utils';
import { PIPELINE_SERVICE_INJECTION_TOKEN, PipelineServiceInterface } from '../pipeline/pipeline-service.interface';
import { PipelineFilterDialogComponent } from './pipeline-table-filter-dialog/pipeline-filter-dialog.component';
import { HAS_ACCESS_TO_SAVE_FILTERS } from './tokens';
import { FiltersCacheObject } from '../pipeline-filters-cache/pipeline-filters-cache.service';
import { PipelineFilterSaverService } from '../pipeline-filters-cache/pipeline-filter-saver.service';

@Component({
  selector: 'sales-ui-pipeline-saved-filters',
  templateUrl: './pipeline-saved-filters.component.html',
  styleUrls: ['./pipeline-saved-filters.component.scss'],
  standalone: false,
})
export class PipelineSavedFiltersComponent implements OnDestroy {
  savedFilters$: Observable<FiltersCacheObject[]>;
  canAccessSaveFilters$: Observable<boolean>;

  private readonly subscriptions = SubscriptionList.new();

  ngOnDestroy(): void {
    this.subscriptions.destroy();
  }

  constructor(
    readonly dialog: MatDialog,
    private readonly filterStorage: PipelineFilterSaverService,
    @Inject(PIPELINE_SERVICE_INJECTION_TOKEN) private readonly pipelineService: PipelineServiceInterface,
    @Inject(HAS_ACCESS_TO_SAVE_FILTERS) private readonly hasAccessSaveFilters$: Observable<boolean>,
  ) {
    this.canAccessSaveFilters$ = this.hasAccessSaveFilters$;
    this.savedFilters$ = filterStorage.savedFilters$;
  }

  applySavedFilter(filterGroup: FiltersCacheObject): void {
    this.pipelineService.applySavedFiltersFromStorage(filterGroup.searchTerm, filterGroup.filters, filterGroup.sort);
  }

  deleteSavedFilter(filterGroupName: string): void {
    this.filterStorage.deleteFilterGroup(filterGroupName);
  }

  async saveCurrentFilters(): Promise<void> {
    const filterGroupNames = this.filterStorage.savedFilters$.pipe(
      map((filterCacheObjects) => filterCacheObjects.map((filterCacheObject) => filterCacheObject.filterName)),
    );

    const groupNames = await firstValueFrom(filterGroupNames);
    this.dialog.open(PipelineFilterDialogComponent, {
      width: '400px',
      data: { savedFilterGroupNames: groupNames },
    });
  }
}
